import { render, staticRenderFns } from "./subject-component.vue?vue&type=template&id=f08f7670&scoped=true&"
import script from "./subject-component.vue?vue&type=script&lang=js&"
export * from "./subject-component.vue?vue&type=script&lang=js&"
import style0 from "./subject-component.vue?vue&type=style&index=0&id=f08f7670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08f7670",
  null
  
)

export default component.exports